/**
 * Perio module (WP2-PERIO, BUILD-PLAN M07). Two screens:
 *  - `/perio`: today's hygiene and perio visits plus unfinished drafts;
 *  - `/patients/$patientId/perio`: the six-point perio chart.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'perio',
    title: 'Perio',
    version: '0.1.0',
    owner: 'WP2-PERIO',
    entitlementKey: null,
    permissions: [
      'perio.view',
      'perio.edit',
      'perio.amend',
      'txplan.edit',
      'txplan.plan_perio',
      'notes.sign',
      'settings.manage',
    ],
    routes: [
      {
        id: 'worklist',
        path: '/perio',
        title: 'Perio',
        officeScope: 'location-or-all',
        permission: 'perio.view',
        readsPhi: true,
      },
      {
        id: 'chart',
        path: '/patients/$patientId/perio',
        title: 'Perio chart',
        officeScope: 'location-or-all',
        permission: 'perio.view',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Perio',
        labelKey: 'perio',
        group: 'clinical',
        routeId: 'worklist',
        icon: 'activity',
        order: 20,
        permission: 'perio.view',
      },
    ],
    commands: [
      {
        id: 'perio.open',
        title: 'Go to Perio',
        keywords: ['periodontal', 'probing', 'pocket depth', 'bleeding', 'srp'],
        routeId: 'worklist',
        permission: 'perio.view',
      },
    ],
    shortcuts: [{ keys: 'g e', description: 'Go to Perio', routeId: 'worklist' }],
    sseEntityKeys: ['perio_exam'],
    phiReadPoints: ['perio.worklist', 'perio.patient', 'perio.exam'],
  }),
  pages: {
    worklist: () => import('./pages/WorklistPage.js'),
    chart: () => import('./pages/PerioPage.js'),
  },
});
